import { render } from "./top-nav.vue?vue&type=template&id=6322dcae&scoped=true&ts=true"
import script from "./top-nav.vue?vue&type=script&lang=ts&setup=true"
export * from "./top-nav.vue?vue&type=script&lang=ts&setup=true"

import "./top-nav.vue?vue&type=style&index=0&id=6322dcae&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6322dcae"],['__file',"src/layout/components/top-nav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6322dcae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6322dcae', __exports__)) {
    console.log('reload')
    api.reload('6322dcae', __exports__)
  }
  
  module.hot.accept("./top-nav.vue?vue&type=template&id=6322dcae&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6322dcae', render)
  })

}


export default __exports__